import { Button } from '@ipfabric/ui-components/Button/Button';
import { SidePanel } from '@ipfabric/ui-components/SidePanel/SidePanel';
import { useStableCallback } from '@ipfabric/ui-components/hooks/useStableCallback';
import { useCustomForm } from '@ipfabric/ui-components/utils/hookForm/useCustomForm';
import { type FC, useState } from 'react';
import { FormProvider, type SubmitHandler } from 'react-hook-form';
import { useApi } from 'utils/request/useApi';
import { ImportSidePanelContent } from './ImportSidePanelContent';
import type { ImportForm } from './importExportConfiguration.types';

interface Props {
  onClose: () => void;
}

export const ImportSidePanel: FC<Props> = (props) => {
  const formMethods = useCustomForm<ImportForm>({
    defaultValues: {
      importEverythingFromFile: true,
      passphrase: '',
    },
  });
  const [importFile, setImportFile] = useState<File | null>(null);

  const api = useApi();

  const [configurationOptions, setConfigurationOptions] = useState(
    new Set<string>(),
  );

  const onSubmit: SubmitHandler<ImportForm> = useStableCallback(
    async (data) => {
      const formData = new FormData();
      if (importFile) {
        formData.append('file', importFile);
      }
      formData.append('passphrase', data.passphrase);
      for (const configurationOption of configurationOptions) {
        formData.append('configurationOptions[]', configurationOption);
      }
      await api.request({
        url: '/appliance-configuration/import',
        method: 'POST',
        data: formData,
        formData: true,
      });

      props.onClose();
    },
  );
  return (
    <FormProvider {...formMethods}>
      <SidePanel
        closeOnBackdropClick={false}
        onClose={props.onClose}
        title='Import configuration'
        footer={
          <div className='flex gap-xs'>
            <Button
              disabled={configurationOptions.size === 0}
              loading={formMethods.formState.isSubmitting}
              variant='primary'
              onClick={formMethods.handleSubmit(onSubmit)}
              type='submit'
              className='grow'
              icon='fa-file-export'
            >
              Import configuration
            </Button>
            <Button variant='outline' onClick={props.onClose} className='grow'>
              Close
            </Button>
          </div>
        }
      >
        <ImportSidePanelContent
          values={configurationOptions}
          onChange={setConfigurationOptions}
          importFile={importFile}
          setImportFile={setImportFile}
        />
      </SidePanel>
    </FormProvider>
  );
};
